/*eslint-disable no-unused-vars*/
import React from 'react';
const latinize = require('latinize');
/*eslint-enable no-unused-vars*/

function stringSanitizer(string) {
  // Handle umlauts.
  latinize.characters['á'] = 'a'
  latinize.characters['č'] = 'c'
  latinize.characters['ě'] = 'e'
  latinize.characters['é'] = 'é'
  latinize.characters['í'] = 'i'
  latinize.characters['ň'] = 'n'
  latinize.characters['ř'] = 'r'
  latinize.characters['š'] = 's'
  latinize.characters['ý'] = 'y'
  latinize.characters['ů'] = 'u'
  latinize.characters['ú'] = 'u'
  latinize.characters['Ú'] = 'u'
  latinize.characters['ž'] = 'z'

  string = latinize(string)

  // Remove any symbols and special characters.
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9 -]+/g, '')
    .replace(/[ -]+/g, '-');
}

export default stringSanitizer;
